import React from "react";
import { createPopper } from "@popperjs/core";
import { useDispatch } from "react-redux";
import { acceptAppointment } from "store/acceptAppointmentSlice";
import { deleteAppointment } from "store/deleteAppointmentSlice";

const NotificationDropdown = ({appointmentId}) => {
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const dispatch = useDispatch();

  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "left-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  const handleAccept = () => {
    dispatch(acceptAppointment(appointmentId))
    .unwrap()
      .then(() => {
        window.location.reload(); 
      })
      .catch(() => {
      });
  }

  const handleDelete = () => {
    dispatch(deleteAppointment(appointmentId))
      .unwrap()
      .then(() => {
        window.location.reload(); 
      })
      .catch(() => {
      });
    closeDropdownPopover();
  };

  return (
    <>
      <a
        className="text-blueGray-500 py-1 px-3"
        href="#pablo"
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        <i className="fas fa-ellipsis-v"></i>
      </a>
      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
        }
      >
        <button
          onClick={handleAccept}
          className= "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
        >
          Accept
        </button>
        <button
          onClick={handleDelete}
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
        >
          Delete
        </button>
        
      </div>
    </>
  );
};

export default NotificationDropdown;
